import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import GroupLink from '../framework/group_link';
import useTranslation from '../../hooks/use_translation';
import { getVariantByLanguage } from '../../utils/helpers';

const LocationCounty = () => {
	const { language, t } = useTranslation('component_location_county');
	const result = useStaticQuery(graphql`
		query LocationCountyComponent {
			allGroup(sort: { group_variants: { title: ASC } }) {
				nodes {
					group_id
					group_variants {
						language {
							code
						}
						group_variant_id
						slug
						title
					}
				}
			}

			allNewLocation(
				filter: { status: { eq: "active" } }
				sort: { name: ASC }
			) {
				nodes {
					groups
					location_id
					location_variants {
						title
					}
				}
			}
		}
	`);

	const groups_data = result.allGroup.nodes;
	const locations = result.allNewLocation.nodes;

	return (
		<div className="location-county">
			<h3 className="title-small">{t('t1')}</h3>
			<div className="row row-cols-1 row-cols-md-4">
				{groups_data.map((group, index) => {
					const locations_filtered = locations.filter((location) => {
						return location.groups.includes(group.group_id);
					});
					if (!locations_filtered || !locations_filtered.length) return;

					const group_variant = getVariantByLanguage(
						language,
						group.group_variants
					);
					if (!group_variant) return;

					return (
						<div className="col pe-lg-0" key={index}>
							<GroupLink
								className="btn btn-lg btn-light bg-gray-100 border-0 d-block w-100 me-1 mb-1"
								groups={[group.group_id]}
								page="mottagningar"
							>
								{group_variant.title}
							</GroupLink>
						</div>
					);
				})}
			</div>
		</div>
	);
};

LocationCounty.propTypes = {
	className: PropTypes.string,
};

export default LocationCounty;
